<template>
  <div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-container class="container" fluid>
      <v-card elevation="6">
        <v-row style="margin: 10px" align="center">
          <v-col cols="2">
            <h3>ارصدة الصناديق</h3>
          </v-col>
          <v-col cols="3">
            <v-select v-model="selectedBoxId" :items="boxes" item-text="boxName" item-value="idBox" label="الصندوق" outlined dense hide-details clearable></v-select>
          </v-col>
          <v-col cols="2">
            <v-text-field v-model="dateFrom" label="من تاريخ" type="date" outlined dense hide-details></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-text-field v-model="dateTo" label="الى تاريخ" type="date" outlined dense hide-details></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-btn color="primary" @click="loadData" :loading="overlay" block>
              <v-icon left>mdi-magnify</v-icon>
              بحث
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-container>

    <!-- Statistics -->
    <v-container class="container" fluid v-if="boxAmounts.length > 0">
      <v-card elevation="6">
        <v-row style="margin: 10px">
          <v-col cols="6">
            <h4>عدد السجلات: {{ boxAmounts.length }}</h4>
          </v-col>
          <v-col cols="6" align="left">
            <h4>المجموع الكلي: {{ totalAmount.toLocaleString("en-US") }} IQD</h4>
          </v-col>
        </v-row>
      </v-card>
    </v-container>

    <v-container class="container" fluid>
      <v-card elevation="6">
        <v-card-title>
          <v-text-field v-model="search" outlined append-icon="mdi-magnify" label="بحث" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="boxAmounts" :items-per-page="15" :search="search" class="table-content">
          <template v-slot:[`item.index`]="{ index }">
            <h4 style="padding: 0 3px">{{ index + 1 }}</h4>
          </template>

          <template v-slot:[`item.amount`]="{ item }">
            <p style="padding: 0 3px; color: #0E734B; font-weight: 600">
              {{ item.amount.toLocaleString("en-US") }}
            </p>
          </template>

          <template v-slot:[`item.date`]="{ item }">
            <p style="padding: 0 3px">
              {{ item.date ? item.date.substring(0, 10) : '' }}
            </p>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "BoxAmounts",
  data: () => ({
    overlay: false,
    search: "",
    boxAmounts: [],
    boxes: [],
    selectedBoxId: null,
    dateFrom: "",
    dateTo: "",
    headers: [
      { text: "التسلسل", value: "index", width: 80 },
      { text: "رقم السجل", value: "idBoxAmount" },
      { text: "اسم الصندوق", value: "boxName" },
      { text: "المبلغ", value: "amount" },
      { text: "التاريخ", value: "date" },
    ],
  }),
  computed: {
    totalAmount() {
      return this.boxAmounts.reduce((sum, item) => sum + (item.amount || 0), 0);
    },
  },
  created() {
    this.initialData();
  },
  methods: {
    initialData() {
      let self = this;
      self.overlay = true;

      self.$http
        .all([
          self.$http.get(`${self.$store.state.apiUrlFees}/boxAmountsWithBoxNames`, {
            headers: { Authorization: `Bearer ${self.$store.state.user}` },
          }),
          self.$http.get(`${self.$store.state.apiUrlFees}/boxes`, {
            headers: { Authorization: `Bearer ${self.$store.state.user}` },
          }),
        ])
        .then(
          self.$http.spread((boxAmountsRes, boxesRes) => {
            self.boxAmounts = boxAmountsRes.data;
            self.boxes = boxesRes.data;
            self.overlay = false;
          })
        )
        .catch((e) => {
          console.log(e);
          self.overlay = false;
          self.$toasted.error("حدث خطأ الرجاء التأكد من الاتصال بالانترنت");
        });
    },
    loadData() {
      let self = this;
      self.overlay = true;

      let params = {};
      if (self.dateFrom) params.dateFrom = self.dateFrom;
      if (self.dateTo) params.dateTo = self.dateTo;
      if (self.selectedBoxId) params.boxId = self.selectedBoxId;

      self.$http
        .get(`${self.$store.state.apiUrlFees}/boxAmountsWithBoxNames`, {
          params,
          headers: { Authorization: `Bearer ${self.$store.state.user}` },
        })
        .then((res) => {
          self.boxAmounts = res.data;
          self.overlay = false;
        })
        .catch((e) => {
          console.log(e);
          self.overlay = false;
          self.$toasted.error("حدث خطأ الرجاء التأكد من الاتصال بالانترنت");
        });
    },
  },
};
</script>
